import { Route } from '@angular/router';
import { GestionComponent } from './gestion.component';

export const GestionRouting: Route = {
  path: "gestion",
  component: GestionComponent,
  data: {
    breadcrumb: "Gestion données statistiques"
  }
}
